import finhomesLogo from "../assets/finhomes-logo.png";
import placeholderIdCard from "../assets/placeholder-id-card.png";
import placeholderDocumentDoc from "../assets/placeholder-document-doc.png";

export const ASSETS = {
  "finhomes-logo.png": finhomesLogo,
  "placeholder-id-card.png": placeholderIdCard,
  "placeholder-document-doc.png": placeholderDocumentDoc,
};

export const asset = (name) => ASSETS[name] || "";

// Real API-provided images (e.g. financier logos) and locally-picked file previews
// (blob: URLs) come back as full URLs, not bundled local filenames — use them
// directly rather than looking them up in ASSETS.
export const resolveImage = (value) => (!value ? "" : /^(https?:|blob:|data:)/.test(value) ? value : asset(value));
